import Folder, { Titulo } from './styles'
import { Container } from '../../styles'
const Hero = () => (
  <Folder>
    <Container>
      <Titulo>
        As melhores vagas para tecnologia, design e artes visuais.
      </Titulo>
    </Container>
  </Folder>
)

export default Hero
